import React from 'react';
import './index.scss';
import classNames from 'classnames';

const AnswerLoading = (props: any) => {
  const { className } = props;
  return (
    <section className={classNames('dba-answer-loading', className)}>
      <div className="dba-load-long"></div>
      <div className="dba-load-mid"></div>
      <div className="dba-load-short"></div>
    </section>
  );
};
export default AnswerLoading;
